import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';

export interface PillTab {
  label: string;
  value: string;
  count?: number | null;
}

/**
 * Segmented pill tabs in a white tray; the active pill is filled indigo with its
 * count in a light badge. Standalone — use it where the filter-section tabs
 * (which bring a search/filter row with them) are too much.
 */
@Component({
  selector: 'app-pill-tabs-reusable',
  standalone: true,
  imports: [CommonModule],
  template: `
    <div class="inline-flex flex-wrap gap-1 rounded-lg border border-slate200 bg-white p-1" role="tablist">
      @for (tab of tabs; track tab.value) {
        @let active = tab.value === activeTab;
        <button
          type="button"
          role="tab"
          [attr.aria-selected]="active"
          class="inline-flex cursor-pointer items-center gap-2 rounded-md px-3 py-1.5 text-sm font-medium transition"
          [ngClass]="active ? 'bg-indigo600 text-white' : 'text-slate700 hover:bg-slate50 hover:text-slate900'"
          (click)="select(tab.value)"
        >
          {{ tab.label }}
          @if (tab.count !== undefined && tab.count !== null) {
            <span
              class="rounded-full px-2 py-0.5 text-xs leading-4"
              [ngClass]="active ? 'bg-white/25 text-white' : 'bg-indigo50 text-indigo700'"
            >
              {{ tab.count }}
            </span>
          }
        </button>
      }
    </div>
  `,
})
export class PillTabsReusableComponent {
  @Input() tabs: readonly PillTab[] = [];
  @Input() activeTab = '';
  @Output() activeTabChange = new EventEmitter<string>();

  protected select(value: string): void {
    if (value === this.activeTab) return;
    this.activeTab = value;
    this.activeTabChange.emit(value);
  }
}
